
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const UpdateButton = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.updateLmStates(props.data);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
            <div onClick={handleRouteClick} className="d-flex justify-content-center align-items-center" title="Update" style={{padding:"3px 15px", height: "auto", lineHeight: "15px", borderRadius: "5px", backgroundColor: "#00c292", color: "#f9f9f9", fontSize: "11px" }}>Update </div>
       
        </div>
    );
};

export default UpdateButton;
